import { css } from '@microsoft/fast-element';

export const UploadValidationStyles = css`
  .table-container {
    width: 100% !important;
    max-height: 225px;
    overflow: scroll;
    margin-top: 18px;
  }

  .table-container::-webkit-scrollbar {
    width: 6px;
    height: 6px;
  }

  .table-container::-webkit-scrollbar-corner {
    background-color: #1f2126;
  }

  .table-container::-webkit-scrollbar-thumb {
    background-color: #35373b;
    border-radius: 5px;
  }

  .table-container::-webkit-scrollbar-thumb:hover {
    background-color: #787878;
  }

  .table-container::-webkit-scrollbar-thumb:active {
    background-color: #acacac;
  }
`;
